
import React, { useEffect, useState, useCallback } from 'react';
import styles from './ErrorBoundary.module.scss';
import logo from '../../assets/Daymap-text-logo-web.png';

const ErrorBoundary  = ({ children }) => {
    const [error, setError] = useState(null);
  
    const onRejection = useCallback((event) => {
      setError(event);
    }, []);
   
    useEffect(() => {
      window.addEventListener("unhandledrejection", onRejection);
      window.addEventListener("error", onRejection);
    }, []);
  
    return error ? 
    (
        <div className={styles.card}>

        <div>
        <img src={logo} className={styles.icon}/>
            <div>
                <h1>Oops - Something went wrong!</h1>

                
            </div>
        </div>
        <div >
            <h2 className={styles.header}>Please try the following:</h2>
            <ul>
                <li>Click the browser "Back" button to return to the previous page.</li>
                <li>Returning to the login screen and trying again.</li>
                <li>Make sure your browser accepts cookies and try again.</li>
                <li>If you suspect authorisation is the problem as the school to grant you access</li>

            </ul>
        </div>

        <div>
           
           
                <div>If you continue to experience this error please contact your school's administrator and include the exception ID listed below.</div>
                <h2 className={styles.header}>Error Message:</h2>
                <div>
                    <span className={styles.title}>Error Message: </span>
                    <span>{error.reason.message}</span>
                </div>
                <div>
                    {
                        !error.reason.message.includes("IP Address") ? <>{<span className={styles.title}>Stack Trace: </span>} {<span>{error.reason.stack}</span>}</> : ''                    
                    }
                </div>
        

        </div>
    </div>
    ) 
    : (children)
  };
  
  export default ErrorBoundary;